import React from "react";
import { AuthLayout } from "../../layout";
import { Card } from "antd";
import { useHistory } from "react-router-dom";

import {
  PureCreateProfile,
  SuggestedForum,
  ContentPreference,
  FavouriteTeams,
} from "../../components/Forms";
import StepProgressBar from "react-step-progress";
import "react-step-progress/dist/index.css";

const RegisterPage = () => {
  const history = useHistory();
  return (
    <AuthLayout>
      <div className="flex text-center 2xl:justify-center">
        <Card
          className="shadow-lg auth-card p-9 w-full 2xl:w-3/4"
        >
          <StepProgressBar
            startingStep={0}
            previousBtnName={"<  Back to Login"}
            secondaryBtnClass="no-border"
            primaryBtnClass="button-secondary w-1/5"
            nextBtnName={"Next Step >"}
            onSubmit={() => {
              history.push("/success");
            }}
            steps={[
              {
                label: "",
                subtitle: "",
                name: "step 1",
                content: <PureCreateProfile />,
              },
              {
                label: "",
                subtitle: "",
                name: "step 2",
                content: <SuggestedForum />,
              },
              {
                label: "",
                subtitle: "",
                name: "step 3",
                content: <ContentPreference />,
              },
              {
                label: "",
                subtitle: "",
                name: "step 4",
                content: <FavouriteTeams />,
              },
            ]}
          />
        </Card>
      </div>
    </AuthLayout>
  );
};

export default RegisterPage;
